import React from 'react';
import DocumentsSection from './DocumentsSection';

function CaseDetailsExtraInfo({
    caseDetails,
    isCaseOpen,
    uploadDocuments,
    removeDoc
}) {
  return (
    <div className='w-full font-plexsans p-4 lg:p-5'>
      <div className='w-full'>
            <DocumentsSection
                caseDetails={caseDetails}
                uploadDocuments={uploadDocuments}
                removeDoc={removeDoc}
                name = "supportingDocuments"
                isCaseOpen={isCaseOpen}
                />
            <DocumentsSection
                caseDetails={caseDetails}
                uploadDocuments={uploadDocuments}
                removeDoc={removeDoc}
                name = "videoDocument"
                isCaseOpen={isCaseOpen}
                />
        {/* "Answer more questions" (additional case details) is turned off for now -
            clients can only add supporting documents and a video after the case is created */}
      </div>
    </div>
  )
}

export default CaseDetailsExtraInfo
